import React, { useEffect, useState } from "react";
import Create from "./Create";
import Edit from "./Edit";
import Alerts from "../Alerts";
import api from "../../api/api";
import DOMPurify from "dompurify";
import { CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";

const View = () => {
  const [options, setOptions] = useState("");
  const [faixasTexto, setFaixasTexto] = useState(null);
  const [selectedFaixa, setSelectedFaixa] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [warning, setWarning] = useState({});

  useEffect(() => {
    // A função só será executada quando `cards` for uma string vazia.
    if (options !== "") return;

    const fetchFeaturedProducts = async () => {
      try {
        const response = await api.get("banners/line");
        setFaixasTexto(response.data.inLineBanners);
      } catch (error) {
        console.error("Erro ao buscar produtos destacados:", error); // É bom manter o log de erros
        setWarning({
          type: "error",
          message: "Falha ao carregar os cards do servidor!",
        });
        handleOpenSnackbar();
      }
    };

    fetchFeaturedProducts();
  }, [options]);

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const handleHtml = (html) => {
    const cleanHTML = DOMPurify.sanitize(html);
    return cleanHTML;
  };

  return (
    <div className="p-0">
      <div className="flex justify-start mb-6">
        <button
          onClick={() => {
            options === "" ? setOptions("create") : setOptions("");
          }}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700 transition-colors flex items-center gap-2"
        >
          {options === "" ? (
            <div className="flex items-center gap-2">
              <AddIcon sx={{ fontSize: 16, color: "white" }} />
              Criar Nova Faixa de Texto
            </div>
          ) : (
            <div className="flex items-center gap-2">
              <ArrowBackIcon sx={{ fontSize: 16, color: "white" }} />
              Voltar
            </div>
          )}
        </button>
      </div>

      {options === "create" ? (
        <Create
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          setOptions={setOptions}
        />
      ) : options === "edit" ? (
        <Edit
          item={selectedFaixa}
          setWarning={setWarning}
          handleOpenSnackbar={handleOpenSnackbar}
          setOptions={setOptions}
        />
      ) : faixasTexto ? (
        <div className="space-y-8">
          {/* Seção "Para você" */}
          <div className="bg-white rounded-lg p-2">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              Para você
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Posição: Topo */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-blue-800 mb-3 flex items-center gap-2">
                  Topo
                </h3>
                {faixasTexto
                  .filter(
                    (faixa) =>
                      faixa.type === "FOR_YOU" && faixa.position === "TOP"
                  )
                  .map((faixa, index) => (
                    <div
                      key={index}
                      className="bg-white border border-blue-200 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex-1">
                          <div className="flex flex-wrap gap-2 mb-2">
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                              Topo
                            </span>
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                              Para você
                            </span>
                            {faixa.button && (
                              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                                Com Cupom
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setOptions("edit");
                            setSelectedFaixa(faixa);
                          }}
                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-1 text-sm"
                        >
                          <EditIcon sx={{ fontSize: 14, color: "white" }} />
                          Editar
                        </button>
                      </div>

                      <div className="bg-gray-50 border border-gray-200 rounded p-3 mb-3">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">
                          Conteúdo:
                        </h4>
                        <div
                          className="text-gray-800 prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{
                            __html: handleHtml(faixa.text),
                          }}
                        />
                      </div>

                      {faixa.button && (
                        <div className="bg-green-50 border border-green-200 rounded p-3">
                          <h4 className="text-sm font-semibold text-green-800 mb-2">
                            Cupom:
                          </h4>
                          <p className="text-sm text-green-700">
                            <span className="font-medium">Código:</span>{" "}
                            {faixa.textButton}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                {faixasTexto.filter(
                  (faixa) =>
                    faixa.type === "FOR_YOU" && faixa.position === "TOP"
                ).length === 0 && (
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                    <p className="text-gray-500">
                      Nenhuma faixa configurada para esta posição
                    </p>
                  </div>
                )}
              </div>

              {/* Posição: Abaixo do Carrossel */}
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-blue-800 mb-3 flex items-center gap-2">
                  Abaixo do Carrossel
                </h3>
                {faixasTexto
                  .filter(
                    (faixa) =>
                      faixa.type === "FOR_YOU" &&
                      faixa.position === "ABOVE_HEADER"
                  )
                  .map((faixa, index) => (
                    <div
                      key={index}
                      className="bg-white border border-blue-200 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex-1">
                          <div className="flex flex-wrap gap-2 mb-2">
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                              Abaixo do Carrossel
                            </span>
                            <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs font-medium">
                              Para você
                            </span>
                            {faixa.button && (
                              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                                Com Cupom
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setOptions("edit");
                            setSelectedFaixa(faixa);
                          }}
                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-1 text-sm"
                        >
                          <EditIcon sx={{ fontSize: 14, color: "white" }} />
                          Editar
                        </button>
                      </div>

                      <div className="bg-gray-50 border border-gray-200 rounded p-3 mb-3">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">
                          Conteúdo:
                        </h4>
                        <div
                          className="text-gray-800 prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{
                            __html: handleHtml(faixa.text),
                          }}
                        />
                      </div>

                      {faixa.button && (
                        <div className="bg-green-50 border border-green-200 rounded p-3">
                          <h4 className="text-sm font-semibold text-green-800 mb-2">
                            Cupom:
                          </h4>
                          <p className="text-sm text-green-700">
                            <span className="font-medium">Código:</span>{" "}
                            {faixa.textButton}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                {faixasTexto.filter(
                  (faixa) =>
                    faixa.type === "FOR_YOU" &&
                    faixa.position === "ABOVE_HEADER"
                ).length === 0 && (
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                    <p className="text-gray-500">
                      Nenhuma faixa configurada para esta posição
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Seção "Para salão" */}
          <div className="bg-white rounded-lg p-2">
            <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
              Para salão
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Posição: Topo */}
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-purple-800 mb-3 flex items-center gap-2">
                  Topo
                </h3>
                {faixasTexto
                  .filter(
                    (faixa) =>
                      faixa.type === "FOR_BUSINESS" && faixa.position === "TOP"
                  )
                  .map((faixa, index) => (
                    <div
                      key={index}
                      className="bg-white border border-purple-200 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex-1">
                          <div className="flex flex-wrap gap-2 mb-2">
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-medium">
                              Topo
                            </span>
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-medium">
                              Para salão
                            </span>
                            {faixa.button && (
                              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                                Com Cupom
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setOptions("edit");
                            setSelectedFaixa(faixa);
                          }}
                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-1 text-sm"
                        >
                          <EditIcon sx={{ fontSize: 14, color: "white" }} />
                          Editar
                        </button>
                      </div>

                      <div className="bg-gray-50 border border-gray-200 rounded p-3 mb-3">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">
                          Conteúdo:
                        </h4>
                        <div
                          className="text-gray-800 prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{
                            __html: handleHtml(faixa.text),
                          }}
                        />
                      </div>

                      {faixa.button && (
                        <div className="bg-green-50 border border-green-200 rounded p-3">
                          <h4 className="text-sm font-semibold text-green-800 mb-2">
                            Cupom:
                          </h4>
                          <p className="text-sm text-green-700">
                            <span className="font-medium">Código:</span>{" "}
                            {faixa.textButton}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                {faixasTexto.filter(
                  (faixa) =>
                    faixa.type === "FOR_BUSINESS" && faixa.position === "TOP"
                ).length === 0 && (
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                    <p className="text-gray-500">
                      Nenhuma faixa configurada para esta posição
                    </p>
                  </div>
                )}
              </div>

              {/* Posição: Abaixo do Carrossel */}
              <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
                <h3 className="text-lg font-semibold text-purple-800 mb-3 flex items-center gap-2">
                  Abaixo do Carrossel
                </h3>
                {faixasTexto
                  .filter(
                    (faixa) =>
                      faixa.type === "FOR_BUSINESS" &&
                      faixa.position === "ABOVE_HEADER"
                  )
                  .map((faixa, index) => (
                    <div
                      key={index}
                      className="bg-white border border-purple-200 rounded-lg p-4 mb-4 shadow-sm hover:shadow-md transition-shadow"
                    >
                      <div className="flex justify-between items-start mb-3">
                        <div className="flex-1">
                          <div className="flex flex-wrap gap-2 mb-2">
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-medium">
                              Abaixo do Carrossel
                            </span>
                            <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-medium">
                              Para salão
                            </span>
                            {faixa.button && (
                              <span className="bg-green-100 text-green-800 px-2 py-1 rounded text-xs font-medium">
                                Com Cupom
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          onClick={() => {
                            setOptions("edit");
                            setSelectedFaixa(faixa);
                          }}
                          className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-700 transition-colors flex items-center gap-1 text-sm"
                        >
                          <EditIcon sx={{ fontSize: 14, color: "white" }} />
                          Editar
                        </button>
                      </div>

                      <div className="bg-gray-50 border border-gray-200 rounded p-3 mb-3">
                        <h4 className="text-sm font-semibold text-gray-700 mb-2">
                          Conteúdo:
                        </h4>
                        <div
                          className="text-gray-800 prose prose-sm max-w-none"
                          dangerouslySetInnerHTML={{
                            __html: handleHtml(faixa.text),
                          }}
                        />
                      </div>

                      {faixa.button && (
                        <div className="bg-green-50 border border-green-200 rounded p-3">
                          <h4 className="text-sm font-semibold text-green-800 mb-2">
                            Cupom:
                          </h4>
                          <p className="text-sm text-green-700">
                            <span className="font-medium">Código:</span>{" "}
                            {faixa.textButton}
                          </p>
                        </div>
                      )}
                    </div>
                  ))}

                {faixasTexto.filter(
                  (faixa) =>
                    faixa.type === "FOR_BUSINESS" &&
                    faixa.position === "ABOVE_HEADER"
                ).length === 0 && (
                  <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 text-center">
                    <p className="text-gray-500">
                      Nenhuma faixa configurada para esta posição
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center h-64">
          <CircularProgress size={60} />
          <p className="mt-4 text-gray-600">Carregando faixas de texto...</p>
        </div>
      )}

      <Alerts
        open={openSnackbar}
        handleClose={handleCloseSnackbar}
        type={warning.type}
        message={warning.message}
      />
    </div>
  );
};

export default View;
